// extracted by mini-css-extract-plugin
module.exports = {"root":"_1PvPU","companyName":"_2ifhu","userInfo":"_1Aqdi","row":"_21Hpb","column":"_2GdSV","infoRow":"_3PRtH","label":"_2X8PR","value":"_1yM5I"};